var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlusThin(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99805 0C8.41212 0.000161018 8.74805 0.335886 8.74805 0.75V7.24805H15.2451C15.6593 7.24805 15.9951 7.58383 15.9951 7.99805C15.9949 8.41211 15.6592 8.74805 15.2451 8.74805H8.74805V15.2451C8.74805 15.6592 8.41212 15.995 7.99805 15.9951C7.58383 15.9951 7.24805 15.6593 7.24805 15.2451V8.74805H0.75C0.335896 8.74805 0.000177501 8.41211 0 7.99805C0 7.58383 0.335786 7.24805 0.75 7.24805H7.24805V0.75C7.24805 0.335786 7.58383 0 7.99805 0Z",
    fill: "#676879"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusThin);
export default __webpack_public_path__ + "static/media/plus-thin.d771f56a.svg";
export { ForwardRef as ReactComponent };